var Tipsters = function() {
    return {
        load_tipsters: function(from, elem, full, username) {
            Generic.showProgressLoader();
            let data = username ?
                {
                    username: username
                }
                :
                {
                    sort: Tipsters.sort,
                    sortorder: Tipsters.sortorder,
                    full: full,
                    from: from,
                    league_id: $('#league_selector').val(),
                    odd_avg: $('#odd_avg_selector').val(),
                    pick: $('#pick_selector').val(),
                    vc: $('#vote_count_selector').val()
                }
            ;
            Ajax.getTipsters(data, (res) => {
                if (res.full) {
                    elem.html(res.html);
                } else {
                    elem.append(res.html);
                }
                Generic.hideProgressLoader();
            });
        },
        // Thead searchable
        searchOnType: function(e) {
            if (e.keyCode === 27) { // On Escape button, revert
                Tipsters.revertSearchable();
            }
            clearTimeout(Tipsters.autocompleteTimer);
            Tipsters.autocompleteTimer = setTimeout(function() {
                var username = $(e.target).val();
                if ([13, 37, 38, 39, 40].indexOf(e.keyCode) < 0) { // On Enter and arrow keys to nothing
                    Tipsters.load_tipsters(0, $('#tipsters_table tbody'), 1, username);
                }
            }, 400);
        },
        // If Desktop, on the teable header on the first column there is a "search" icon element. We register
        // a click event on that in order to switch the th innerHtml with the search input.
        // If mobile, the table header does not have the "search" icon element in order to trigger click event,
        // but has an additional input in filters. Thus, we register a keyup event for that input field.
        initSearchable: function() {
            if ($('#ii__search-init').length > 0) { // Desktop
                $('#ii__search-init').on('click', function(e) {
                    $('#tipsters_table #ii__search-init').parent().html('<input class="ii__search-username" placeholder="Όνομα Χρήστη"></input>');
                    $('#tipsters_table th:first-child')[0].style.padding = '6px';
                    $('.ii__search-username').keyup(Tipsters.searchOnType);
                    $('.ii__search-username').focus();
                    window.addEventListener('click', Tipsters.clickRevertSearchable, false);
                });
            } else { // Mobile
                $('.ii__search-username').keyup(Tipsters.searchOnType);
            }
        },
        clickRevertSearchable: function(e) {
            if (
                !$(e.target).hasClass('ii__search-username') &&
                !$(e.target).hasClass('fa-search') &&
                !$(e.target).hasClass('pointable')
            ) {
                Tipsters.revertSearchable();
            }
        },
        revertSearchable: function() {
            $('#tipsters_table .ii__search-username').parent().html(
                '<span id="ii__search-init" class="pointable">ΟΝΟΜΑ ΧΡΗΣΤΗ <i class="icon fal fa-search"></i></span>'
            );
            $('#tipsters_table th:first-child')[0].style.padding = '8px 6px 2px 6px';
            Tipsters.initSearchable();
            window.removeEventListener('click', Tipsters.clickRevertSearchable, false);
        },
        // End of thead searchable
        init: function(sort, sort_order) {
            Tipsters.sort = sort;
            Tipsters.sortorder = sort_order;
            $('.ii__filters').change(function(e) {
                if ($(this).attr('id') == 'pick_selector' &&
                    $('#league_selector').val() != '') {
                    $('#league_selector').val(-1);
                }
                if ($(this).attr('id') == 'league_selector' &&
                    $('#pick_selector').val() != '') {
                    $('#pick_selector').val('');
                }
                Tipsters.load_tipsters(0, $('#tipsters_table tbody'), 1);
            });
            $(document).on('click', '.ii__showmore_btn', function(e){
                var from = $('.ii__showmore_btn').data('from');
                var elem = $('.ii__showmore_btn').parent().parent();
                $('.ii__showmore_btn').parent().remove();
                Tipsters.load_tipsters(from, elem, 0);
            });
            $(document).on('click', '.ii__sortable_col', function(e){
                if (Tipsters.sort == $(this).data('sort')) {
                    Tipsters.sortorder = Tipsters.sortorder == 'desc' ? 'asc' : 'desc';
                } else {
                    Tipsters.sortorder = 'desc';
                }
                Tipsters.sort = $(this).data('sort');
                Tipsters.updateSortIcons(this);
                Tipsters.load_tipsters(0, $('#tipsters_table tbody'), 1);
            });
            Tipsters.initSearchable();
        },
        updateSortIcons: function(element) {
            var thisHtml = $(element).html().trim();
            var siblings = $('#tipsters_table thead').find('th');
            var orderIcon = '<i class="fas fa-angle-' +
                (Tipsters.sortorder == 'asc' ? 'up' : 'down') +
                '" style="margin-left: 7px;line-height: 1px; position: relative; font-size: 20px; top: 3px;"></i>';
            for (var i = 0; i < siblings.length; i++) {
                var th = siblings[i],
                    thHtml = $(th).html().trim();

                $(th).html(thHtml.replace(/<i(.*?)<\/i>/, ''));

                if (thHtml === thisHtml) {
                    $(th).html($(th).html() + ' ' + orderIcon);
                }
            }
        }
    };
}();
